// EN
import enHKContent from '../assets/translation/hk/en/en.json';
// SC
import scHKContent from '../assets/translation/hk/sc/sc.json';
// TC
import tcHKContent from '../assets/translation/hk/tc/tc.json';

import { LANGUAGE, REGION } from './constants';


const getLanguage = (language) => {
    const list = Object.values(LANGUAGE);
    const lang = languageFormat(language)
    if (list.includes(lang)) {
      return lang;
    } 
    console.warn(
      `can't match any language (${language}), set ${LANGUAGE.EN} as default.`
    );
    return LANGUAGE.EN;
};

const getContentMessage = (country, language) => {
  const CONTENT_MESSAGES = {
    [LANGUAGE.EN]: {
      HK: { ...enHKContent },
    },

    [LANGUAGE.SC]: {
      HK: {
        ...scHKContent
      },
    },
    [LANGUAGE.TC]: {
      HK: {
        ...tcHKContent
      },
    },
  };

  const localeMessages = CONTENT_MESSAGES[language] || CONTENT_MESSAGES[LANGUAGE.EN]; // default to english if language not found
  return localeMessages[country] || localeMessages[REGION.HK]; // default to Hong Kong if country not found
};

const languageFormat = (value) => {
  switch (value) {
    case 'zh-hk':
    case 'zh_hk':
    case 'TC':
      return "zh-hk"
    case 'zh-cn':
    case 'zh_cn':
    case 'SC':
      return 'zh-cn'
    case 'en-us':
    case 'en_us':
    case 'EN':
      return 'en-us'
    default:
      break;
  }
}

const initMultiLingual = (props) => {
  const { country } = props;
  const language = getLanguage(props.language);

  return getContentMessage(country, language);
};

export default initMultiLingual;
export { getLanguage };